import {
  Body,
  Button,
  Dialog,
  DialogFooter,
  DialogSection,
  Row,
} from '@leanin/ui';

export interface UnsavedChangesDialogProps {
  readonly open: boolean;
  readonly onCancel: () => void;
  readonly onSave: () => void;
  readonly onDiscard: () => void;
  readonly saveDisabled?: boolean;
  readonly saveDisabledReason?: string;
  readonly savePending?: boolean;
  readonly error?: string | null;
}

export function UnsavedChangesDialog({
  open,
  onCancel,
  onSave,
  onDiscard,
  saveDisabled,
  saveDisabledReason,
  savePending,
  error,
}: UnsavedChangesDialogProps) {
  // DialogSection self-hides when it has no renderable children, so the
  // reason/error body never leaves an empty band when both are absent.
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onCancel();
      }}
      title="Save changes to draft?"
      description="You have unsaved changes. They will be lost if you leave without saving."
      size="sm"
    >
      <DialogSection gap="md">
        {saveDisabled === true && saveDisabledReason !== undefined ? (
          <Body size="sm" color="mute">
            {saveDisabledReason}
          </Body>
        ) : null}
        {error !== null && error !== undefined ? (
          <Body size="sm" color="destructive">
            {error}
          </Body>
        ) : null}
      </DialogSection>
      <DialogFooter justify="space-between">
        <Button variant="ghost" onClick={onCancel} disabled={savePending}>
          Cancel
        </Button>
        <Row gap="sm" style={{ flexShrink: 0 }}>
          <Button
            variant="secondary"
            onClick={onDiscard}
            disabled={savePending}
          >
            Discard
          </Button>
          <Button
            variant="primary"
            onClick={onSave}
            disabled={saveDisabled || savePending}
            loading={savePending}
          >
            Save
          </Button>
        </Row>
      </DialogFooter>
    </Dialog>
  );
}
